// extracted by mini-css-extract-plugin
export default {"productCarousel":"P2-z"};